/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import SubscriptionsidSubscription from './SubscriptionsidSubscription';

/**
 * The SubscriptionsIdBody model module.
 * @module model/SubscriptionsIdBody
 * @version v0.3
 */
export default class SubscriptionsIdBody {
  /**
   * Constructs a new <code>SubscriptionsIdBody</code>.
   * @alias module:model/SubscriptionsIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SubscriptionsIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SubscriptionsIdBody} obj Optional instance to populate.
   * @return {module:model/SubscriptionsIdBody} The populated <code>SubscriptionsIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SubscriptionsIdBody();
      if (data.hasOwnProperty('subscription'))
        obj.subscription = SubscriptionsidSubscription.constructFromObject(data['subscription']);
    }
    return obj;
  }
}

/**
 * @member {module:model/SubscriptionsidSubscription} subscription
 */
SubscriptionsIdBody.prototype.subscription = undefined;

